module.exports = __webpack_public_path__ + "img/weather_station.c127637d.svg";